export const getItemRequestDetail = (state) => state.itemRequestDetail;